import { useField } from '@unform/core';
import React, { InputHTMLAttributes, useEffect, useRef } from 'react';
import { ContainerCheck, ContainerLabel, Error, Span } from './styles';

interface checkboxProps extends InputHTMLAttributes<HTMLInputElement> {
  checked?: boolean;
  name: string;
  value?: string;
  noShowValue?: boolean;
  themeColor?: string;
}

const Checkbox: React.FC<checkboxProps> = ({
  className,
  value,
  name,
  noShowValue,
  title,
  themeColor,
  ...rest
}) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField, error, clearError } =
    useField(name);
  const defaultChecked = defaultValue === value;
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: (ref) => {
        return ref.current.checked;
      },
      clearValue: (ref) => {
        // eslint-disable-next-line no-param-reassign
        ref.current.checked = defaultChecked;
      },
      setValue: (ref, v) => {
        clearError();
        // eslint-disable-next-line no-param-reassign
        ref.current.checked = v;
      },
    });
  }, [defaultValue, fieldName, registerField, defaultChecked, clearError]);

  return (
    <ContainerLabel className={className}>
      <ContainerCheck themeColor={themeColor}>
        <input
          defaultChecked={defaultChecked}
          ref={inputRef}
          value={value}
          type="checkbox"
          id={fieldName}
          name={name}
          {...rest}
        />
      </ContainerCheck>
      {!noShowValue && (
        <Span className={error ? '-hasError' : ''}>{title || value}</Span>
      )}
      {error && (
        <Error>
          <div className="errorCheckbox errorForm">
            <span>{error}</span>
          </div>
        </Error>
      )}
    </ContainerLabel>
  );
};

export default Checkbox;
